import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfoboxService } from 'src/app/services/infobox.service';

@Component({
  selector: 'app-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.sass']
})
export class InfoboxComponent implements OnInit {

  boxId:any;
  infobox:any;
  infoboxes:any = [];

  constructor(
    private infoboxService:InfoboxService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;
    if(!params) return;
    this.boxId = params["boxid"];

    this.infoboxService.getBoxes().subscribe(data => {
      for(let b of data.data) {
        b = this.infoboxService.populateBox(b);
        if(b.id == this.boxId) {
          this.infobox = b;
        } else {
          this.infoboxes.push(b);
        }
      }
    })
  }

}
